<template>
    <div>
        <keep-alive>
            <div class="row">
                <vs-divider>REPORTES REGULATORIOS</vs-divider>
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <vx-card class="text-center feedback">
                        <vs-button @click="$router.push('/reportes-regulatorios/consulta')" type="line" size="large">
                        Consulta Reportes
                        </vs-button>
                    </vx-card>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <vx-card class="text-center feedback">
                        <vs-button @click="$router.push('/reportes-regulatorios/RX')" type="line" size="large">
                        R01, R10 y R13 
                        </vs-button>
                    </vx-card>
                </div>
                <!-- <div class="col-sm-12 col-md-6 col-lg-3">
                    <vx-card class="text-center feedback">
                        <vs-button @click="$router.push('/reportes-regulatorios/R01')" type="line" size="large">R01/112
                        </vs-button>
                    </vx-card>
                </div> -->
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <vx-card class="text-center feedback">
                        <vs-button @click="$router.push('/reportes-regulatorios/R27')" type="line" size="large">
                        R27 Reclamaciones
                        </vs-button>
                    </vx-card>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3">
                    <vx-card class="text-center feedback">
                        <vs-button @click="$router.push('/reportes-regulatorios/R08')" type="line" size="large">
                        R08 Prestamos Obtenidos
                        </vs-button>
                    </vx-card>
                </div>
            </div>
            <router-view>

            </router-view>
        </keep-alive>
    </div>
</template>

<script lang="js">
    export default {
        name: 'reportesRegulatorios',
    }
</script>